import { RoomTypeQuestions } from '../protos/backendproto/QuestionService_pb';
import { SaveInteriorQuestionsRequest } from '../protos/adminbackendproto/AdminQuestionService_pb';
import QuestionsWorkspace, { GroupAdapter } from './QuestionsWorkspace';

const interiorAdapter: GroupAdapter<RoomTypeQuestions> = {
    title: "Interior questions",
    noun: "room",
    groups: (response) => response.getQuestionsPerRoomList(),
    name: (room) => room.getRoomName(),
    setName: (room, name) => { room.setRoomName(name) },
    create: () => new RoomTypeQuestions(),
    save: (client, rooms) => client.saveInteriorQuestions(
        new SaveInteriorQuestionsRequest().setQuestionsPerRoomList(rooms), {}),
};

export default function InteriorQuestionsPage() {
    return <QuestionsWorkspace adapter={interiorAdapter} />
}
